/**
 * CONFIGURACIÓN GLOBAL DEL SISTEMA
 * ==================================
 * 
 * Para cambiar el tema institucional:
 * 1. Modifica el ID del tema en CURRENT_THEME_ID
 * 2. O usa la página de Temas (solo superadmin)
 * 
 * Temas disponibles: base, educacion, salud, gobierno, corporativo, creativo, naranja, rojo
 */

import { getThemeById } from './themes';

// ▼▼▼ CAMBIA AQUÍ EL TEMA (por ID) ▼▼▼
const CURRENT_THEME_ID = 'base';
// ▲▲▲ CAMBIA AQUÍ EL TEMA ▲▲▲

// Obtener tema actual (desde sessionStorage si existe, sino del config)
const savedThemeId = typeof sessionStorage !== 'undefined'
    ? sessionStorage.getItem('currentThemeId')
    : null;
//const currentTheme = getThemeById(savedThemeId || CURRENT_THEME_ID);
const currentTheme = getThemeById(CURRENT_THEME_ID);

export const SystemConfig = {

    // ============================================
    // CONFIGURACIÓN DEL NAVEGADOR
    // ============================================
    browserTitle: "Ana Belen - Sistema de Seguimiento de Votos",

    // ============================================
    // INFORMACIÓN DEL SISTEMA
    // ============================================
    appName: "Sistema de Seguimiento de Votos",
    appDescription: "Ing. Jheyson Gaitan",

    // ============================================
    // RECURSOS (logos, imágenes)
    // ============================================
    logoPath: "/logos/APRA.svg", // Archivo en carpeta public/

    // ============================================
    // FOOTER
    // ============================================
    footerText: "Ing. Jheyson Gaitan - © {year}",

    // ============================================
    // TEMA ACTUAL (objeto completo)
    // ============================================
    theme: currentTheme,

    // ID del tema por defecto (para reset)
    defaultThemeId: CURRENT_THEME_ID,
};
